import { render, staticRenderFns } from "./CommonPageInfo.vue?vue&type=template&id=7b37a641&scoped=true"
import script from "./CommonPageInfo.vue?vue&type=script&lang=js"
export * from "./CommonPageInfo.vue?vue&type=script&lang=js"
import style0 from "./CommonPageInfo.vue?vue&type=style&index=0&id=7b37a641&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37a641",
  null
  
)

export default component.exports